import React from 'react';
import {
  Box,
  Typography,
  // Button,
  // Card,
  // CardContent,
  // Link
} from '@mui/material';
import { YouTubeContent1 } from '../resources/YouTubeContent';
import { ResourceYoutubeCard } from '../resources/ResourceYoutubeCard';
//import { useNavigate } from 'react-router-dom';


export const DrArturoExplains: React.FC = () => {
  return (
    <Box
      sx={{
        width: "100%",
        py: 3
      }}
    >
      <Typography
        variant="h5"        
        fontWeight="bold"
        sx={{ mb: 3 }}
      >
        Dr. Arturo explains:
      </Typography>

      <Typography
        variant="h7"
        
        fontWeight="bold"
        sx={{ mb: 3 }}
    >
        What Are Clinical Trials?
      </Typography>

      <Typography variant="body1" sx={{mb: 3}}>
        Cancer is an unfortunate reality that touches most of us at some point in our lives. If you or a loved one has cancer, you may have heard or read that clinical trials could offer access to innovative new options. But what exactly is a clinical trial? In this video, Dr. Arturo Loaiza-Bonilla, MD, explains how clinical trials work, what to expect if you enroll in one, and why a clinical trial can be an important option for many cancer patients.
      </Typography>
      <YouTubeContent1 videoId={'UgZG1ZuVQs4?si=ltJjtFBhPkcK0kQk'} title={''} description={''} isPlaying={false} />
    </Box>
  );
};


export const NewMultipleMyelomaOptions: React.FC = () => {
  return (
    <Box
      sx={{
        width: "100%",
        py: 3
      }}
    >
      <Typography
        variant="h5"        
        fontWeight="bold"
        sx={{ mb: 3 }}
      >
        New Multiple Myeloma Options
      </Typography>
      <Typography variant="body1" sx={{mb: 3}}>
      If you’ve battled Multiple Myeloma without success through multiple different treatments, we understand your journey. Our advanced AI system will match and suggest a range of potential new myeloma trials selected specifically for you. Our case managers, experts in oncology informatics, will evaluate your submission and reach out to you.      </Typography>
      <YouTubeContent1 videoId={'azNZLgEUpII'} title={''} description={''} isPlaying={false} />
      {/* <ResourceYoutubeCard  linkData={{youtubeUrl: 'https://www.youtube.com/watch?v=azNZLgEUpII'}} isPlaying={false}  /> */}
      <Typography variant="body1" sx={{py: 3}}>
      Exploring other choices is important when standard treatments don’t work for multiple myeloma cancer. We have a special opportunity for patients who are seeking for new options for multiple myeloma and have tried standard treatments or are newly diagnosed and have not begun treatment.
      </Typography>
      {/* <Typography variant="body1" sx={{mb: 3}}>
      <strong>Our new system helps find clinical trials for multiple myeloma for free.</strong> Sign up for our AI matching system to receive a personalized multiple myeloma cancer options tailored to your needs.
      </Typography> */}
      <Typography variant="body1" sx={{mb: 3}}>
        When standard treatments for Multiple Myeloma are no longer effective—or for those newly diagnosed—clinical trials may offer additional options. Massive Bio provides a free AI-powered matching system that connects patients with personalized trial opportunities based on their medical profile. Signing up is simple and provides access to potential new treatments.</Typography>
    </Box>
  )
};